import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../Icon';
import { WHATSAPP_DISPLAY, whatsappLink } from '../../../constants/contact';
import styles from './WhatsAppButton.module.css';

/** Green chat button pinned to the bottom-right corner of every page. */
const WhatsAppButton: React.FC = () => (
  <a
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.fab}
    aria-label={`Chat with us on WhatsApp, ${WHATSAPP_DISPLAY}`}
  >
    <Icon icon={FaWhatsapp} className={styles.icon} aria-hidden="true" />
    <span className={styles.label}>Chat with us</span>
  </a>
);

export default WhatsAppButton;
